import { gql } from "@codesandbox/api";
import { cleanup } from "impact-react";

import type { EditorStoreProps } from "./types";

const incrementSandboxVersionQuery = gql.createMutation(
  "IncrementSandboxVersion",
  ({ sandboxId }: { sandboxId: string }) => ({
    incrementSandboxVersion: [{ sandboxId }],
  }),
);

export function useEditor(props: EditorStoreProps) {
  const { pitcher, editor, api } = props;

  // We want to keep the sandbox version updated whenever we save a file in a Devbox
  const disposeSaveListener = pitcher.clients.file.onFileSave(() => {
    if (editor.type === "sandbox" && editor.isCloud) {
      api.gql.query(incrementSandboxVersionQuery, { sandboxId: editor.id });
    }
  });

  cleanup(() => {
    disposeSaveListener.dispose();
  });

  /**
   * This object will take over the editor data and management. Each property will become a signal,
   * which optimises the rendering and you'll get all methods related to changing the editor on the same object
   */
  return {};
}
